import { forwardRef } from 'react'
import type { JSX } from 'react'

import styles from './content.module.scss'

/** Empty container for any sort of content with min/max width. */
export const Content = forwardRef<HTMLElement, Props>(
    ({ children, tag: Tag = 'div', ...restOfProps }, ref) => (
        <Tag ref={ref as any} className={styles.content} {...restOfProps}>
            {children}
        </Tag>
    ),
)

interface Props extends Omit<JSX.IntrinsicElements['div'], 'className'> {
    tag?: 'div' | 'section'
}
